import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { Question } from '../types';

interface QuestionCardProps {
  question: Question;
  value?: number;
  onChange: (score: number) => void;
}

export default function QuestionCard({ question, value, onChange }: QuestionCardProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  
  const handleScore = (newScore: number) => {
    setShowTooltip(false); // Hide tooltip when selecting score
    onChange(newScore);
  };

  return (
    <div className="p-4 md:p-6 bg-[#BACCC7] rounded-lg">
      <div className="flex items-start gap-2 mb-3">
        <div className="flex-grow">
          <div className="flex items-center gap-2">
            <label className="text-sm md:text-base text-[#163B56] font-semibold">
              {question.text}
            </label>
            <button
              type="button"
              className="text-[#163B56]/60 hover:text-[#163B56] transition-colors"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              <HelpCircle className="w-4 h-4" />
            </button>
          </div>
          {showTooltip && (
            <div className="mt-2 text-xs md:text-sm text-gray-600 bg-white/95 p-2 rounded-md shadow-sm border border-gray-200">
              {question.tooltip}
            </div>
          )}
        </div>
        {value && (
          <span className="text-xs md:text-sm font-medium px-2 py-1 bg-[#163B56]/10 text-[#163B56] rounded">
            {value}/10
          </span>
        )}
      </div>

      <div className="grid grid-cols-5 md:grid-cols-10 gap-1 md:gap-2">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((score) => (
          <button
            key={score}
            type="button"
            onClick={() => handleScore(score)}
            className={`p-1 md:p-2 rounded-md text-xs md:text-sm font-medium transition-all duration-200 ${
              score === value
              ? 'bg-[#163B56] text-white ring-2 ring-[#163B56] ring-offset-2'
              : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
            }`}
          >
            {score}
          </button>
        ))}
      </div>

      <div className="flex justify-between text-xs md:text-sm text-[#163B56] mt-2">
        <span>Needs Improvement</span>
        <span>Excellent</span>
      </div>
    </div>
  );
}